import { createSelector } from 'reselect';
import { constants } from '@clearscore/redux.market';

import getCurrentPath from './getCurrentPath';

const marketRegExCaptureGroup = RegExp(`^/(${constants.MARKETS.join('|')})(.*)$`, 'gi');

export default createSelector(getCurrentPath, (currentPath) =>
    currentPath && currentPath.match(marketRegExCaptureGroup)
        ? currentPath.replace(marketRegExCaptureGroup, '$1').toLowerCase()
        : null,
);
